"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BarLoader = _interopRequireDefault(require("react-spinners/BarLoader"));

var _Fonts = require("../00_environment/Fonts");

var _Mountains = _interopRequireDefault(require("../01_atoms/Mountains"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingScreen = function LoadingScreen(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100vh'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Mountains["default"], {
    style: {
      flex: '1'
    },
    width: "100vw",
    height: "60vh"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '20%' //   width: '100vw',

    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: (0, _Fonts.withWidgetSubtitleFont)({
      fontSize: '16px'
    })
  }, "".concat(text, "...")), /*#__PURE__*/_react["default"].createElement(_BarLoader["default"], {
    css: {
      margin: 10,
      width: '100%',
      maxWidth: 200
    },
    color: "#722B7C" // "#5DA895"
    ,
    loading: true
  })));
};

var _default = LoadingScreen;
exports["default"] = _default;